export default __webpack_public_path__ + "static/charms-3486f78abd969b8713d19ed896f082d1.png";